import { useEffect, useRef } from 'react';
import { store } from '../store';
import type {
  InjectReducerParams,
  InjectSagaParams,
  RootStateKeyType,
} from './types/injector-typings';

/**
 * Destify-compatible inject hooks (custom implementation — redux-injectors
 * does not support React 19 peer deps). Default saga mode is DAEMON.
 */
export function useInjectReducer<Key extends RootStateKeyType>(
  params: InjectReducerParams<Key>,
): void {
  const injected = useRef(false);
  if (!injected.current) {
    store.injectReducer(params.key, params.reducer);
    injected.current = true;
  }

  useEffect(() => {
    store.injectReducer(params.key, params.reducer);
  }, [params.key, params.reducer]);
}

export function useInjectSaga(params: InjectSagaParams): void {
  const injected = useRef(false);
  if (!injected.current) {
    store.injectSaga(params.key, params.saga);
    injected.current = true;
  }

  useEffect(() => {
    store.injectSaga(params.key, params.saga);
  }, [params.key, params.saga]);
}
